<template>
  <div class="resolution-ui-wrapper">
    <v-alert type="error">
      There was an error determining how to complete this step.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "ErrorResolutionUI"
};
</script>

<style scoped></style>
